import { ExternalLink } from 'lucide-react';
import type { ReferenceDocumentView } from '@/lib/api/generated/casedb';
import { ReferenceDocumentLinks } from './ReferenceDocumentLinks';
import { EMPTY_VALUE_LABEL } from '@/features/catalog_case_review/shared/constants/caseReviewLabels';

export interface AssessmentReferenceValueProps {
  databaseId: string;
  documents?: ReferenceDocumentView[];
  dailyMedUrl?: string;
  inputId?: string;
}

/** Local reference documents take precedence over DailyMed, as in Case Review. */
export function AssessmentReferenceValue({ databaseId, documents, dailyMedUrl, inputId }: AssessmentReferenceValueProps) {
  if (documents?.length) return <ReferenceDocumentLinks documents={documents} />;
  if (dailyMedUrl) return <a href={dailyMedUrl} target="_blank" rel="noopener noreferrer"
    className="inline-flex items-center gap-1 text-viz-blue hover:underline break-all"
    title="Open Section 6 on DailyMed">{databaseId}<ExternalLink size={10} aria-hidden="true" /></a>;
  return <output id={inputId} data-empty={!databaseId || undefined}>{databaseId || EMPTY_VALUE_LABEL}</output>;
}
